import { render, staticRenderFns } from "./floorDetail.vue?vue&type=template&id=508b8a90&scoped=true"
import script from "./floorDetail.vue?vue&type=script&lang=js"
export * from "./floorDetail.vue?vue&type=script&lang=js"
import style0 from "./floorDetail.vue?vue&type=style&index=0&id=508b8a90&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b8a90",
  null
  
)

export default component.exports